module.exports = {"120117100":"芦台镇","120117102":"宁河镇","120117103":"苗庄镇","120117104":"丰台镇","120117105":"岳龙镇","120117106":"板桥镇","120117107":"潘庄镇","120117109":"造甲城镇","120117110":"七里海镇","120117111":"大北涧沽镇","120117112":"东棘坨镇","120117204":"北淮淀乡","120117205":"俵口乡","120117206":"廉庄子乡","120117400":"宁河县贸易开发区","120117401":"宁河县经济开发区","120117402":"一汽大众华北工业园","120117403":"天津未来科技城","120117451":"宁河县现代产业园区","120117452":"天津潘庄工业区","120117500":"潘庄农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/120117.json
// module id = 53
// module chunks = 0